export default __webpack_public_path__ + "static/media/icon-location.a681f02d.svg";